import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import residenceDocumentListAction from './residenceDocumentList.action.json' with { type: 'json' }
import { residenceDocumentObject } from '../residenceDocumentObject'

export const residenceDocumentExpression = expression(residenceDocumentObject.shape)

const residenceDocumentListDefinition = defineAction({
  ...residenceDocumentListAction,

  input: z.object({
    filter: residenceDocumentExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      fileName: 'Nome do arquivo',
      mimeType: 'Tipo MIME',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(residenceDocumentObject),
    count: z.number(),
  }),
})

export default residenceDocumentListDefinition
